export default {"src":"/_next/static/media/web.43e4ff76.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};